// extracted by mini-css-extract-plugin
var _1 = "AgreementRowStyle-module__broker___dPf_p";
var _2 = "AgreementRowStyle-module__broker-name___iYSWm";
var _3 = "AgreementRowStyle-module__broker-section___oMjbU";
var _4 = "AgreementRowStyle-module__broker-name___iYSWm";
var _5 = "AgreementRowStyle-module__broker-section___oMjbU";
var _6 = "AgreementRowStyle-module__sign-agreement___Mqglu";
var _7 = "AgreementRowStyle-module__sign-agreement___Mqglu";
var _8 = "AgreementRowStyle-module__tick____DQ2X";
export { _1 as "broker", _2 as "broker-name", _3 as "broker-section", _4 as "brokerName", _5 as "brokerSection", _6 as "sign-agreement", _7 as "signAgreement", _8 as "tick" }
